import React, { PureComponent } from 'react';

import ColorSelector from './color-selector';
import Popout from './popout';

export default class ColorPicker extends PureComponent {
    handleToggleClick = () => {
        this.show();
    }

    handleSelect = color => {
        this.props.onSelect && this.props.onSelect(color)

        this.hide();
    }

    show() {
        this.popoutCtrl && this.popoutCtrl.show();
    }

    hide() {
        this.popoutCtrl && this.popoutCtrl.hide();
    }

    setCtrl = ctrl => this.popoutCtrl = ctrl

    componentDidMount() {
        const ctrl = {
            show: () => {
                this.show();
            },
            hide: () => {
                this.hide();
            }
        };

        if (this.props.provideController) {
            if ('current' in this.props.provideController) {
                this.props.provideController.current = ctrl;
            } else {
                this.props.provideController && this.props.provideController(ctrl);
            }
        }
    }

    componentWillUnmount() {
        this.hide();

        if (this.props.provideController) {
            if ('current' in this.props.provideController) {
                this.props.provideController.current = null;
            } else {
                this.props.provideController && this.props.provideController(null);
            }
        }
    }

    render() {
        const childrenWithProps = React.Children.map(this.props.children, child => {
            return React.cloneElement(child, {
                onClick: this.handleToggleClick
            });
        });

        return (
            <React.Fragment>
                { childrenWithProps }

                <Popout
                    className="auto-size color-picker"
                    xAlign={this.props.xAlign}
                    defaultXPosition={this.props.defaultXPosition}
                    provideController={this.setCtrl}
                >
                    <ColorSelector
                        selected={this.props.selected}
                        withTransparent={this.props.withTransparent}
                        compact={this.props.compact}
                        onChange={this.handleSelect}
                    />
                </Popout>
            </React.Fragment>
        )
    }
}
